define('constants/signupSessionFlowConstants',[], function() {
    return {
        'flowA': "cdn1",
        'flowB': "cdn2",
        'flowC': "cdn3",
        'flowD': "cdn4",
        'flowAgent': "agent"
    };
});
